module.exports = __webpack_public_path__ + "img/construction-icon.1973bcca.png";